import type { ProspectHomepageSlide } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';

import { CMSHTML, CMSImage } from '@swf/cms';

import styles from './ColumnLayout.scss';

interface Props {
  images: ProspectHomepageSlide['image_with_text'][];
}

const Images: React.FC<Props> = ({ images }) => (
  <div className={styles.row}>
    {images.map(({ image, text }, i) =>
      image.asset ? (
        <div key={i} className={styles.imageWrapper}>
          <CMSImage {...image} />
          <CMSHTML {...text} className={styles.imageText} />
        </div>
      ) : (
        <div key={i} className={classNames(styles.imageWrapper, styles.bottomBorder)} />
      )
    )}
  </div>
);

export default Images;
